import { LumberListPrototype, LumberSet } from '@paragon/contract-library';

export function countLumbersInLumberList(list: LumberListPrototype) {
  return list.lumberSets.reduce((sum, set) => sum + countLumbersInLumberSet(set), 0);
}

export function countLumbersInLumberSet(set: LumberSet) {
  return (
    set.species.length *
    set.grades.length *
    set.treatmentTypes.length *
    set.actualDimensions1.length *
    set.actualDimensions2.length
  );
}
